
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App"; // Importing the main App component

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App /> {/* Render the main App component */}
  </React.StrictMode>
);
